import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const NotFound = lazy(() => import('../pages/NotFound'));
const Home = lazy(() => import('../pages/home/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const Reports = lazy(() => import('../pages/reports/page'));
const Expenses = lazy(() => import('../pages/expenses/page'));
const FleetPage = lazy(() => import('../pages/fleet/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));

/**
 * ⚠️ La route « /admin » A ÉTÉ RETIRÉE.
 *
 * Elle servait `pages/admin/page.tsx`, une console de démonstration câblée sur
 * `src/mocks/fleet.ts` : au premier chargement elle écrivait des conducteurs
 * fictifs dans localStorage (`myautolink_fleet_drivers`) et les affichait
 * comme des vraies données. C'est ce qui donnait à l'app son air d'application
 * de démonstration.
 *
 * La console d'administration réelle est un build séparé : admin.html,
 * `src/admin/`, déployé sur admin.autolink.lu. Voir
 * specs/SPEC-05-vues-de-gestion-deploiement.md.
 *
 * Les fichiers de la démo sont à SUPPRIMER du dépôt — la liste exacte est
 * dans NETTOYAGE-DEMO.md. Tant qu'ils y sont, ils partent dans le bundle
 * téléchargé par chaque conducteur.
 */
const routes: RouteObject[] = [
  { path: '/', element: <Suspense fallback={<PageLoader />}><Home /></Suspense> },
  { path: '/tracking', element: <Suspense fallback={<PageLoader />}><Tracking /></Suspense> },
  { path: '/reports', element: <Suspense fallback={<PageLoader />}><Reports /></Suspense> },
  { path: '/expenses', element: <Suspense fallback={<PageLoader />}><Expenses /></Suspense> },
  { path: '/profile', element: <Suspense fallback={<PageLoader />}><Profile /></Suspense> },
  { path: '/fleet', element: <Suspense fallback={<PageLoader />}><FleetPage /></Suspense> },
  { path: '/reset-password', element: <Suspense fallback={<PageLoader />}><ResetPasswordPage /></Suspense> },
  { path: '/support', element: <Suspense fallback={<PageLoader />}><SupportPage /></Suspense> },
  { path: '*', element: <Suspense fallback={<PageLoader />}><NotFound /></Suspense> },
];

function PageLoader() {
  return (
    <div
      style={{
        position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
        padding: 'calc(var(--safe-t) + 20px) 20px 0', gap: 14,
      }}
    >
      <div style={{ height: 168, borderRadius: 18, background: 'var(--sk)', animation: 'alSk 1.2s infinite' }} />
      <div style={{ display: 'flex', gap: 12 }}>
        <div style={{ flex: 1, height: 86, borderRadius: 16, background: 'var(--sk)', animation: 'alSk 1.2s infinite .1s' }} />
        <div style={{ flex: 1, height: 86, borderRadius: 16, background: 'var(--sk)', animation: 'alSk 1.2s infinite .15s' }} />
      </div>
      <div style={{ height: 200, borderRadius: 16, background: 'var(--sk)', animation: 'alSk 1.2s infinite .2s' }} />
    </div>
  );
}

export default routes;
